export const SET_PUZZLES = 'SET_PUZZLES';
export const SET_PUZZLE = 'SET_PUZZLE';
export const ADD_PUZZLE = 'ADD_PUZZLE';
export const ADD_PUZZLES = 'ADD_PUZZLES';
export const UPDATE_PUZZLE = 'UPDATE_PUZZLE';
export const REMOVE_PUZZLE = 'REMOVE_PUZZLE';
export const CLEAR_PUZZLE = 'CLEAR_PUZZLE';
export const CLEAR_PUZZLES = 'CLEAR_PUZZLES';
